import {
    faCactus,
    faCampground,
    faChessRook,
    faClouds,
    faFlowerTulip,
    faHome,
    faPlanetRinged,
    faRocket,
    faRv,
    faSnowflake,
    faTrafficLight,
    faTreeAlt,
    faWater,
} from '@fortawesome/pro-solid-svg-icons';
import loginUser from 'actions/authentication/login';
import axios from 'axios';
import Button from 'components/UI/Button/Button';
import React, { createContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Dropdown from './Dropdown/Dropdown';
import Footer from './Footer/Footer';
import './Login.module.scss';
import StartpointWrapper from './StartpointWrapper/StartpointWrapper';
import TestButton from './TestButton/TestButton';
import Top from './Top/Top';

export type Colors =
    | 'blue'
    | 'red'
    | 'orange'
    | 'yellow'
    | 'sand'
    | 'mint'
    | 'green'
    | 'purple'
    | 'black';
export type BuildingTypes =
    | 'huis'
    | 'boomhut'
    | 'kasteel'
    | 'tent'
    | 'raket'
    | 'camper'
    | 'luchtballon';
export type GroundPlanes =
    | 'gras'
    | 'water'
    | 'stad'
    | 'woestijn'
    | 'space'
    | 'sneeuw'
    | 'fantasie';
export type ExpandedMenuTypes = 'none' | 'buildings' | 'colors' | 'groundplane';
export type Options = {
    option: BuildingTypes | GroundPlanes | Colors;
    icon?: any;
    name?: string;
}[];

export const buildingOptions: Options = [
    { option: 'huis', icon: faHome },
    { option: 'kasteel', icon: faChessRook },
    { option: 'boomhut', icon: faTreeAlt },
    { option: 'tent', icon: faCampground },
    { option: 'luchtballon', icon: faClouds },
    { option: 'raket', icon: faRocket },
    { option: 'camper', icon: faRv },
];
const groundPlaneOptions: Options = [
    { option: 'gras', icon: faFlowerTulip },
    { option: 'water', icon: faWater },
    { option: 'stad', icon: faTrafficLight },
    { option: 'woestijn', icon: faCactus },
    { option: 'space', icon: faPlanetRinged },
    { option: 'sneeuw', icon: faSnowflake },
    { option: 'fantasie', icon: faClouds },
];

const colorsOptions: Options = [
    { option: 'blue', name: 'blauw' },
    { option: 'yellow', name: 'geel' },
    { option: 'red', name: 'rood' },
    { option: 'orange', name: 'oranje' },
    { option: 'sand', name: 'zand' },
    { option: 'mint', name: 'mint' },
    { option: 'green', name: 'groen' },
    { option: 'purple', name: 'paars' },
    { option: 'black', name: 'zwart' },
];

export type SvgProps = {
    selectedColor: Colors;
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    loginUser,
};
type loginContextTypes = {
    expandedMenu: ExpandedMenuTypes;
    setExpandedMenu: React.Dispatch<React.SetStateAction<ExpandedMenuTypes>>;
    groundPlane: GroundPlanes;
    buildingType: BuildingTypes;
    selectedColor: Colors;
    setSelectedColor: React.Dispatch<React.SetStateAction<Colors>>;
    username: string;
    setUsername: React.Dispatch<React.SetStateAction<string>>;
    password: string;
    setPassword: React.Dispatch<React.SetStateAction<string>>;
    setLoginFailed: React.Dispatch<React.SetStateAction<boolean>>;
};
export const loginContext = createContext({} as loginContextTypes);

function Login(props: { loginUser: any }) {
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [groundPlane, setGroundPlane] = useState<GroundPlanes>('gras');
    const [buildingType, setBuildingType] = useState<BuildingTypes>('huis');
    const [selectedColor, setSelectedColor] = useState<Colors>('blue');
    const [loginFailed, setLoginFailed] = useState(false);

    const [expandedMenu, setExpandedMenu] = useState<ExpandedMenuTypes>('none');

    useEffect(() => {
        // get cookie we need for loggin in
        axios.get('/sanctum/csrf-cookie').then(() => {});
    }, []);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        const combinedLogin = `${username.toLowerCase()}_${groundPlane}_${buildingType}_${selectedColor}`;

        props
            .loginUser({
                username: combinedLogin,
                password,
            })
            .then(() => {})
            .catch(() => {
                setLoginFailed(true);
            });
    }

    return (
        <loginContext.Provider
            value={{
                expandedMenu,
                setExpandedMenu,
                groundPlane,
                buildingType,
                selectedColor,
                setSelectedColor,
                username,
                setUsername,
                password,
                setPassword,
                setLoginFailed,
            }}
        >
            <div styleName="container">
                <form styleName="box" onSubmit={handleSubmit}>
                    <div style={{ display: 'grid', gap: '10px' }}>
                        <Top loginFailed={loginFailed} />
                        <div styleName="code">
                            <Dropdown
                                type="groundplane"
                                options={groundPlaneOptions}
                                setState={setGroundPlane}
                            />
                            <Dropdown
                                type="buildings"
                                options={buildingOptions}
                                setState={setBuildingType}
                            />
                            <Dropdown
                                type="colors"
                                options={colorsOptions}
                                setState={setSelectedColor}
                            />
                        </div>
                    </div>
                    <StartpointWrapper
                        selectedColor={selectedColor}
                        buildingType={buildingType}
                        groundPlane={groundPlane}
                    />
                    <Button>LOG IN</Button>
                </form>
                <TestButton />
                <Footer />
            </div>
        </loginContext.Provider>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
